// Semantic design tokens — mapują znaczenie (surface, content, action, status, progress)
// na wartości primitive. Komponenty powinny odwoływać się TYLKO do tej warstwy (lub component/).
import { color, radius, shadow } from './primitive';
import { contrastTextColor } from '../contrast';

function hexToRgb(hex) {
  const sanitized = hex.replace('#', '');
  const bigint = parseInt(sanitized, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return Number.isNaN(bigint) ? null : [r, g, b];
}

function buildSemanticTokens(mode, primaryColor, accentColor) {
  const neutral = mode === 'dark' ? color.neutralDark : color.neutralLight;
  const brandMain = primaryColor || (mode === 'dark' ? color.brand[300] : color.brand[500]);
  const energyMain = accentColor || (mode === 'dark' ? color.energy[300] : color.energy[400]);
  const rgb = primaryColor ? hexToRgb(primaryColor) : null;
  const brandTint = rgb ? `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${mode === 'dark' ? 0.16 : 0.08})` : (mode === 'dark' ? 'rgba(155, 135, 255, 0.16)' : color.brand[50]);

  return {
    surface: {
      canvas: neutral.canvas,
      base: neutral.surface,
      elevated: neutral.elevated,
      overlay: mode === 'dark' ? 'rgba(23, 21, 27, 0.72)' : 'rgba(23, 21, 31, 0.5)',
      brandTint,
    },
    content: {
      primary: neutral.ink,
      secondary: neutral.inkSoft,
      muted: neutral.muted,
      onBrand: contrastTextColor(brandMain),
      onEnergy: color.neutralLight.ink,
    },
    action: {
      primary: brandMain,
      primaryHover: mode === 'dark' ? color.brand[300] : color.brand[600],
      primaryPressed: mode === 'dark' ? color.brand[500] : color.brand[700],
      secondary: neutral.surface,
      secondaryBorder: neutral.line,
      onPrimary: contrastTextColor(brandMain),
    },
    status: {
      positive: color.semantic.positive,
      warning: color.semantic.warning,
      danger: color.semantic.danger,
      info: color.semantic.info,
    },
    progress: {
      track: mode === 'dark' ? 'rgba(168, 235, 95, 0.16)' : 'rgba(93, 159, 32, 0.14)',
      fill: energyMain,
      fillStrong: color.energy[600],
    },
    border: {
      subtle: neutral.line,
      strong: neutral.muted,
    },
    shadow: {
      float: shadow.float,
      soft: shadow.soft,
    },
    radius,
  };
}

export function getSemanticTokens(mode = 'light', primaryColor, accentColor) {
  return mode === 'dark'
    ? buildSemanticTokens('dark', primaryColor, accentColor)
    : buildSemanticTokens('light', primaryColor, accentColor);
}
